import React from 'react'

import { Button } from '@fourthwall/components'

import { DomainString } from '../DomainString/DomainString'
import * as S from './DomainSuggestions.styled'

type DomainSuggestionsProps = {
  title?: string
  suggestions: string[]
  claimLabel: string
  isClaiming: boolean
  onClaim: (domain: string) => void
}

export const DomainSuggestions = ({
  title = 'Alternative options:',
  suggestions,
  claimLabel = 'Claim',
  isClaiming,
  onClaim,
}: DomainSuggestionsProps) => {
  const renderSuggestion = (suggestion: string) => {
    return (
      <S.SuggestionItem>
        <S.DomainName>
          <DomainString domain={suggestion} />
        </S.DomainName>
        <Button
          label={claimLabel}
          size="xsmall"
          loading={isClaiming}
          onClick={() => onClaim(suggestion)}
        />
      </S.SuggestionItem>
    )
  }

  return (
    <div>
      <S.Header>{title}</S.Header>

      {suggestions.map(renderSuggestion)}
    </div>
  )
}
